<template>
  <v-container fluid full-width style="padding: 0px;height:100%;width:100%" :style="containerStyle">
    <v-layout row wrap>
      <v-flex id = "videocontain" xs12 sm12 md12 lg12 xl12 >
        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" style="position: relative; width:100% ;height:100vh;overflow: hidden;"> 
                                  
          <video id='videocase' ref="video" autoplay playsinline webkit-playsinline style="padding: 0px;position:absolute;width:100%;height:100%;object-fit: cover;border:none"></video>
          <!-- <canvas ref="canvas"></canvas> -->
          <canvas ref="canvasoverlay" width=100% height="100%" style="display:none ;position: absolute; background: transparent; top: 0%; right: 0; left: 0; left: 0%;pointer-events: none"></canvas>
          <div class="text-container" width=100% height="auto" >
          <!-- <div id="estimated_age" style="font-size: 14px;">Estimated age: - </div>
          <div id="lighting" style="font-size: 10px;">Lighting: - </div>
          <div id="blur" style="font-size: 10px;">Blur: -</div>
          <div id="head_tilt" style="font-size: 10px;">Head_tilt: -</div>
          <div id="head_left_right" style="font-size: 10px;">Head_left_right: -</div>
          <div id="head_up_down" style="font-size: 10px;">Head_up_down: -</div> -->

          <div id="estimated_age" style="font-size: 180%; background-color: rgb(240,248,255,0.5);">Estimated age: - </div>
          <v-layout row wrap style="background-color: rgb(240,248,255,0.5);">
            <v-flex  xs12 sm12 md1></v-flex>
          
	  <v-flex  xs12 sm12 md2 id="lighting" style="font-size: 120%;">Lighting: - </v-flex>
          <v-flex  xs12 sm12 md2 id="blur" style="font-size: 120%;">Blur: -</v-flex>
          <v-flex  xs12 sm12 md2 id="head_tilt" style="font-size: 120%;">Head Pose Z: -</v-flex>
          <v-flex  xs12 sm12 md2 id="head_left_right" style="font-size: 120%;">Head Pose Y: -</v-flex>
          <v-flex  xs12 sm12 md2 id="head_up_down" style="font-size: 120%;">Head Pose X: -</v-flex>
          <v-flex xs12 class="mt-2">
                <span class="headline" style="font-weight: bold; color: #2f3a5d">🤳 Keep camera at eye level</span>
          </v-flex>
          </v-layout>
          </div>
          
                                          
                                    
        </div>
        
      </v-flex>
      <!-- <v-flex xs12 sm12 md12 lg12 xl12 class="analysis" style="z-index: 2;">  -->
          
        
        <!-- </v-flex> -->
    </v-layout>
    </v-container>
    
    
</template>
  
  <script>
  import axios from "axios";
  
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  axios.defaults.withCredentials = false;
  
  
  export default {
    name: "ConitnuousAge",
    data() {
      return {
          loading: false,
          predictioncl: "",
          // api_url:"http://127.0.0.1:8082/",
          isCameraOpen: false,
          isLoading: false,
          socket :null,
          video : null,
          ctx_overlay: null,
          lines: [], 
          
  
      };
    },
    mounted() {
    this.handleWindowResize(); // Call the function on initial mount
    // Add event listener for window resize
    window.addEventListener('resize', this.handleWindowResize);
    this.toggleCamera();
    
    },
    beforeMount() {
      this.socketconnect();
    },
    beforeDestroy() {
      // Remove event listener when the component is destroyed
      window.removeEventListener('resize', this.handleWindowResize);
      this.socketdisconnect();
    },
    methods: {
      handleWindowResize() {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        // Determine the shortest length (width or height)
        // const shortestLength = Math.max(windowWidth, windowHeight);

        // // Update the CSS property dynamically
        // this.containerStyle = {
        // width: `${shortestLength}px`,
        // height: `${shortestLength}px`,
        // };
      },
      socketconnect() {
          this.$socket = io('https://fallback-server-for-on-browser.privately.swiss:8999')
          // $socket is socket.io-client instance
          this.$socket.on("connect", () => {
            console.log('WebSocket connection established.');
            // captureVideo();
            });
      }, 
      socketdisconnect() {

            this.$socket.disconnect();
            // $socket is socket.io-client instance
            this.$socket.on("disconnect", () => {
              console.log('WebSocket disconnected.');
              // captureVideo();
              });
      }, 
      clickButton(data) {
            // $socket is socket.io-client instance
            this.$socket.emit('emit_method', data)
      },
      sendtoparent(information){
          parent.postMessage(information,"*")
      },     
      toggleCamera() {
        // if(this.isCameraOpen) {
        //   this.isCameraOpen = false;
        //   this.socketdisconnect();
        //   this.stopCamera();
        //   document.getElementById("videocontain").style.textAlign = 'center'
        //   document.getElementById("stopbutton").style.display = 'none';
        //   document.getElementById("startbutton").style.display = 'inline-block';
  
        // } else {
          this.isCameraOpen = true;
          this.startCamera();
          document.getElementById("videocontain").style.textAlign = 'left'
          // document.getElementById("stopbutton").style.display = 'inline-block';
          // document.getElementById("startbutton").style.display = 'none';
          
        // }
      },
      drawLines(coordinates) {

        const canvasoverlay = this.$refs.canvasoverlay;
        const video = this.$refs.video;
        this.$ctx_overlay = canvasoverlay.getContext('2d');
        // console.log("videoWidth"+)
        this.$ctx_overlay.width = video.offsetWidth;
        this.$ctx_overlay.height = video.offsetHeight;
        // console.log("Width = "+video.offsetWidth + "height:" +video.offsetHeight)
        this.$ctx_overlay.clearRect(0, 0, video.offsetWidth , video.offsetHeight);

        this.$ctx_overlay.beginPath();
        this.$ctx_overlay.setLineDash([3, 5]);
        this.$ctx_overlay.strokeStyle = 'blue';
        this.$ctx_overlay.lineWidth = 0.1;

        for (let i = 0; i < coordinates.length; i++) {
          this.$ctx_overlay.moveTo(coordinates[i][0][0], coordinates[i][0][1]);
          this.$ctx_overlay.lineTo(coordinates[i][1][0], coordinates[i][1][1]);
          this.$ctx_overlay.stroke();
        }
      },
      updateResponse(data){
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        // const ctx_overlay = this.$canvas_overlay.getContext("2d");

        // // Draw bounding box
        // ctx.strokeStyle = 'red';
        // ctx.lineWidth = 2;

        
        // this.drawLines(data['face_contours']);

        // ctx.fillStyle = 'blue';
        // ctx.font = '16px Arial';
        if ( data['estimated_age']=="Bad Env/Pose" || data['estimated_age']=='-' || data['estimated_age']=='No Face detected') {
            document.getElementById("estimated_age").style.color = 'red';
        } else {
            document.getElementById("estimated_age").style.color = 'green';
        }
        if ( data['estimated_age']=='-' || data['estimated_age']=='No Face'){
          data['estimated_age'] = 'No Face detected'
        }
        document.getElementById('estimated_age').innerText = "Estimated age: " + data['estimated_age'];
        if ( data['lighting'][0]=='good') {
            document.getElementById("lighting").style.color = 'grey';
        } else {
            document.getElementById("lighting").style.color = 'red';
        }
        document.getElementById("lighting").innerText = "Lighting: " + data['lighting'][0] 
        // + "(" + data['lighting'][1] + ")";

        document.getElementById("blur").innerText = "Blur: " + data['blur'][0] 
        // + "(" + data['blur'][1] + ")";

        if ( data['blur'][0]=='clear') {
            document.getElementById("blur").style.color = 'grey';
        } else {
            document.getElementById("blur").style.color = 'red';
        }

        if ( data['head_tilt'][0]=='straight') {
            document.getElementById("head_tilt").style.color = 'grey';
        } else {
            document.getElementById("head_tilt").style.color = 'red';
        }
        document.getElementById("head_tilt").innerText = "Head Pose Z: "+data['head_tilt'][0] 
        // + "(" + data['head_tilt'][1] + ")";
        if ( data['head_left_right'][0]=='straight') {
            document.getElementById("head_left_right").style.color = 'grey';
        } else {
            document.getElementById("head_left_right").style.color = 'red';
        }
        document.getElementById("head_left_right").innerText = "Head Pose Y: " + data['head_left_right'][0] 
        // + "(" + data['head_left_right'][1] + ")";

        if ( data['head_up_down'][0]=='straight') {
            document.getElementById("head_up_down").style.color = 'grey';
        } else {
            document.getElementById("head_up_down").style.color = 'red';
        }
        document.getElementById("head_up_down").innerText = "Head Pose X:" + data['head_up_down'][0] 
        // + "(" + data['head_up_down'][1] + ")";
      },
      startCamera() {
      // this.socketconnect();
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.videoStream = stream;
            this.$refs.video.srcObject = stream;
            this.startFrameRelay();
          })
          .catch((error) => {
            console.error('Error accessing camera:', error);
          });
      } else {
        console.error('getUserMedia is not supported');
      }
    },
    stopCamera() {
      // this.socketdisconnect();
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => {
          track.stop();
        });
        this.$refs.video.srcObject = null;
        this.stopFrameRelay();
      }
    },

      startFrameRelay() {
      // Get the canvas element
      const canvas = this.$refs.canvasoverlay;
      const video = this.$refs.video;
      const context = canvas.getContext('2d');

      // Create a new image every 100ms and send it to the server
      setInterval(() => {
        canvas.width = video.videoWidth;
			  canvas.height = video.videoHeight;
        context.drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
        const imageData = canvas.toDataURL('image/jpeg');
        // Send the image data to the server via Socket.IO
        this.$socket.emit('image',{'image': imageData});
        // requestAnimationFrame(sendFrame);
        this.$socket.on('image_resp', (data) => {
        // console.log("Estimated Age: "+ data['estimated_age']);
        this.updateResponse(data)
        // sending data to parent iframe
        var information = {
          estimated_age:  data['estimated_age'],
        };
        this.sendtoparent(information);
      });

      },200);

      
    
    },
    stopFrameRelay() {
      // Disconnect from the Socket.IO server
      if (this.$socket) {
        this.$socket.disconnect();
        this.$socket = null;
      }
    },

      resetpredictionlabel() {
        this.predictionResult = "--";
        this.predictionScore = " ";
        document.getElementById("prediction").style.color = "#000000";
      },

    },
  };
  </script>
  <style>
    .analysis{
      z-index: 2;
    
    }
    .button{
      border: 1px solid #fff;
    color: #fff;
    padding: 10px;
    border-radius: 8px;
    display: inline-block;
    text-align: center;
    margin: 10px 10px 10px 10px;
    text-decoration:none;
    text-align: center;
    width:250px;
    height: 50px;
    font-weight: bold;
  }
  #stopbutton{
      border: 1px solid #fff;
    color: #fff;
    padding: 10px;
    border-radius: 8px;
    display: none;
    text-align: center;
    margin: 10px 10px 10px 10px;
    text-decoration:none;
    text-align: center;
    width:250px;
    height: 50px;
    font-weight: bold;
    /* display: none; */
  }
  .text-container{
    position: absolute; 
    /* background: transparent;  */
    text-align: center;
    top: 0%; 
    right: 0%; 
    left: 0%; 
    pointer-events: none;
    /* background:rgba(255, 255, 255, 0.25); */
    /* text-shadow: -1px -1px 0 #493a3a, 1px -1px 0 #493a3a, -1px 1px 0 #493a3a, 1px 1px 0 #493a3a; */
    letter-spacing: 1px;
    -webkit-text-stroke: 5px #f6f1f1;
    font-weight:bold;
    background-color: #ffffff
    
  }
  #videocase{
    transform: rotateY(180deg);
    -webkit-transform:rotateY(180deg); /* Safari and Chrome */
    -moz-transform:rotateY(180deg); /* Firefox */
    border:none;

  }
  </style>

  
  
  
  
  
